import React from 'react';
import { intelligentCareData } from '../data/mock';
import { Shield, Eye, Activity, Bell } from 'lucide-react';

const IntelligentCareSection = () => {
  return (
    <section className="py-24 md:py-32 bg-[#1A2B3C]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Content Grid - Image Left, Text Right */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Image Side */}
          <div className="relative order-2 lg:order-1">
            <div className="relative rounded-xl overflow-hidden shadow-2xl">
              <img
                src={intelligentCareData.image}
                alt="Guardian AI - Intelligent Care Monitoring"
                className="w-full h-[400px] md:h-[500px] object-cover"
              />
              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-[#1A2B3C]/60 to-transparent" />
              
              {/* Tech overlay effect */}
              <div className="absolute inset-0 bg-[#D4AF37]/5" />
            </div>
            
            {/* Decorative elements */}
            <div className="absolute -top-4 -right-4 w-20 h-20 border-r-2 border-t-2 border-[#D4AF37]/60" />
            <div className="absolute -bottom-4 -left-4 w-20 h-20 border-l-2 border-b-2 border-[#D4AF37]/60" />
            
            {/* Floating badge */}
            <div className="absolute -bottom-6 right-8 bg-[#D4AF37] text-[#1A2B3C] px-6 py-4 rounded-lg shadow-xl">
              <div className="flex items-center gap-3">
                <Shield className="w-5 h-5" />
                <span className="font-playfair text-lg">Guardian AI</span>
              </div>
            </div>
          </div>

          {/* Text Side */}
          <div className="order-1 lg:order-2">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-12 h-px bg-[#D4AF37]" />
              <span className="font-lato text-[#D4AF37] uppercase tracking-[0.2em] text-xs">Intelligent Care</span>
            </div>

            <h2 className="font-playfair text-4xl md:text-5xl text-white mb-6 leading-tight">
              {intelligentCareData.headline}
            </h2>

            <p className="font-lato text-white/70 text-lg leading-relaxed mb-8">
              {intelligentCareData.body}
            </p>

            {/* Feature Grid */}
            <div className="grid grid-cols-2 gap-6 mb-8">
              <div className="p-4 rounded-lg bg-white/5 border border-white/10">
                <Eye className="w-6 h-6 text-[#D4AF37] mb-3" />
                <h4 className="font-lato text-white text-sm font-medium mb-1">Privacy First</h4>
                <p className="font-lato text-white/50 text-xs">No intrusive cameras</p>
              </div>
              <div className="p-4 rounded-lg bg-white/5 border border-white/10">
                <Activity className="w-6 h-6 text-[#D4AF37] mb-3" />
                <h4 className="font-lato text-white text-sm font-medium mb-1">Health Patterns</h4>
                <p className="font-lato text-white/50 text-xs">Continuous monitoring</p>
              </div>
              <div className="p-4 rounded-lg bg-white/5 border border-white/10">
                <Bell className="w-6 h-6 text-[#D4AF37] mb-3" />
                <h4 className="font-lato text-white text-sm font-medium mb-1">Instant Alerts</h4>
                <p className="font-lato text-white/50 text-xs">Immediate response</p>
              </div>
              <div className="p-4 rounded-lg bg-white/5 border border-white/10">
                <Shield className="w-6 h-6 text-[#D4AF37] mb-3" />
                <h4 className="font-lato text-white text-sm font-medium mb-1">Fall Detection</h4>
                <p className="font-lato text-white/50 text-xs">Acoustic sensors</p>
              </div>
            </div>

            <button className="font-lato px-8 py-4 bg-[#D4AF37] text-[#1A2B3C] rounded hover:bg-[#D4AF37]/90 transition-all duration-300 font-medium">
              Learn About Our Technology
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntelligentCareSection;
